import React from 'react';
import PropTypes from 'prop-types';

const Instruction = ({ instructions }) => (
  <ul className='flex flex-col md:flex-row justify-around bg-floral-white'>
    {instructions.map((instruction, i) => (
      <li key={i} className="flex flex-1 p-3">
        <div>
          <div className="rounded-full h-10 w-10 flex items-center justify-center border border-primary-dark mx-2 mt-1">
            {i + 1}
          </div>
        </div>
        <div>
          <p className="text-black">
            {instruction.title}
          </p>
          <p className="text-xs text-dim-gray">
            {instruction.description}
          </p>
        </div>
      </li>
    ))}
  </ul>
)

Instruction.propTypes = {
  instructions: PropTypes.array,
}

export default Instruction
